import ajax from './ajax';

export const getJobLocations = (params="")=> {
  return ajax(`/JobLocation/locations${params}`);
};
